import {useState, useEffect, useRef} from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Select,
  message,
  Upload,
} from 'antd';
import {useDispatch} from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {createPuntoVenta, updatePuntoVenta} from '../../../redux/slices/puntosVenta';
import {normFile, beforeUpload, dummyRequest} from '../../../utils/images';
import Close from '../../../components/Close';
import styles from '../styles/Editor.module.css';
import {
  GoogleMap,
  useJsApiLoader,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import { ReactComponent as Gps } from "../../../assets/icons/gps.svg";

const {Option} = Select;
const libraries = ['places', 'geometry', 'drawing'];

const Editor = ({close, puntoVenta, handlePuntoVenta, types}) => {
  const [sending, handleSending] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey:"AIzaSyDcHXx5bT0lelig3L2bzK7sBcQUYFaLxoc",
    libraries:libraries
  });
  const searchbox = useRef(null);
  const [mapLoaded, handleMapLoaded] = useState(false);
  const map = useRef(null);
  const containerStyle = {
    width: "100%",
    height: "400px",
  };
  const [mapCenter, setMapCenter] = useState({
    lat: 13.701319108430834,
    lng: -89.22441469943618,
  });

  useEffect(() => {
    const initialFetch = async () => {
      if (puntoVenta && mapLoaded) {
        const typeExists = types.some(type => type.id === puntoVenta.typeId);

        const newValues = {
          name: puntoVenta.name,
          type: typeExists ? puntoVenta.typeId : undefined
        };
        form.setFieldsValue(newValues);
        var location = JSON.parse(puntoVenta.position)
        setMapCenter({
          lat: parseFloat(location.lat),
          lng: parseFloat(location.lng),
        });
      }
    };
    initialFetch();
  }, [puntoVenta,mapLoaded]);

  const save = async () => {
    try {
      handleSending(true);
      const values = await form.validateFields();
      const info = {};
      const newCenter = map.current.getCenter().toJSON();      
      if (puntoVenta) {
        info.id = puntoVenta.id
      }
      info.name = values.name
      info.description = "-"
      info.type = values.type
      info.position = JSON.stringify({ lat: newCenter.lat, lng: newCenter.lng })

      console.log(info)
     
      if (puntoVenta) {
        const response = await dispatch(updatePuntoVenta(puntoVenta.id, info));
        if (response.status === 'success') {
          message.success('Cambios realizados con éxito');
          close()
        } else if (response.type === 'incomplete') {
          handleSending(false);
          message.warning('Ingresa todos los datos');
        } else {
          message.error('¡Hubo un problema! Inténtalo de nuevo');
        }
      } else {
        const response = await dispatch(createPuntoVenta(info));
        if (response.status === 'success') {
          message.success('Cambios realizados con éxito');
          handlePuntoVenta(response.category);
          close()
        } else if (response.type === 'incomplete') {
          handleSending(false);
          message.warning('Ingresa todos los datos');
        } else {
          message.error('¡Hubo un problema! Inténtalo de nuevo');
        }
      }
      handleSending(false);
    } catch (e) {
      console.log("eee",e)
      message.error('¡Hubo un problema! Inténtalo de nuevo');
    }
  };

  const onPlacesChanged = () => {
    console.log("entro!!")
    const location = searchbox.current.getPlaces()[0].geometry.location;
    map.current.setCenter({
      lat: location.lat(),
      lng: location.lng(),
    });
  };

  const renderMap = () => {
    const onLoadSearchbox = (ref) => {
      console.log("entro de nuevo?")
      searchbox.current = ref;
      handleMapLoaded(true);
    };

    const onLoadMap = (ref) => {
      map.current = ref;
    };

    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        onLoad={onLoadMap}
        zoom={16}
        options={{
          disableDefaultUI: true,
          zoomControl: true,
          fullscreenControl: false,
        }}
      >
        <StandaloneSearchBox
          onLoad={onLoadSearchbox}
          onPlacesChanged={onPlacesChanged}
        >
          <input
            type="text"
            placeholder="Buscar..."
            className={styles.searchbox}
          />
        </StandaloneSearchBox>
      </GoogleMap>
    );
  };

  return (
    <div className={styles.editor}>
      <div className={styles.header}>
        <span className={styles.title}>
          {puntoVenta ? 'Editar Punto de venta' : 'Nuevo Punto de venta'}
        </span>
        <Close action={close} />
      </div>
      <Form
        name="branch-editor"
        autoComplete="off"
        form={form}
        colon={false}
        requiredMark={false}
        onFinish={save}
        className={styles.form}
      >
        <Row gutter={20}>
          <Col span={12}>
            <Form.Item
              label={
                <span className={styles.label}>
                  NOMBRE
                </span>
              }
              name="name"
              className={styles.itemColumn}
              rules={[{required: true, message: 'Ingresar nombre'}]}
            >
              <Input size="large" className={styles.input} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span className={styles.label}>
                  TIPO DE CATEGORÍA
                </span>
              }
              name="type"
              className={styles.itemColumn}
              rules={[{required: true, message: 'Ingresar tipo'}]}
            >
              <Select size="large" className={styles.input}>
                {types.map(type => (
                  <Option key={type.id} value={type.id}>{type.type}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>        
        <Row gutter={20}>
          <Col span={24}>
            <div className={styles.mapWrapper}>
              {isLoaded && renderMap()}
              {isLoaded && <Gps className={styles.gps} />}
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item className={styles.itemSubmit}>
              <Button
                loading={sending}
                className={styles.submit}
                size="large"
                type="primary"
                htmlType="submit">
                GUARDAR PUNTO VENTA
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default Editor;
